import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 로그 수집기 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getCollectorList() {
    return axios.get(`${baseUrl}/settings/lms-collector/get-collector-list.do`);
  },

  /**
   * 로그 저장 경로 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getLogCollectPath() {
    return axios.get(`${baseUrl}/settings/lms-collector/get-collector-path.do`);
  },
  /**
   * 수집기 재탐색
   * @author leesy918
   * @return {[type]} [description]
   */
  searchLogCollector() {
    return axios.get(`${baseUrl}/settings/lms-collector/search-log-collector.do`);
  },
  /**
   * 로그 저장 경로 수정
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateCollectPath(params) {
    return axios.post(`${baseUrl}/settings/lms-collector/update-collect-path.do`, params);
  },
  /**
   * 로그 수집기 설정 변경
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateCollectSetting(params) {
    return axios.post(`${baseUrl}/settings/lms-collector/update-collect-setting.do`, params);
  },
  /**
   * 로그 수집기 삭제
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteCollector(params) {
    return axios.post(`${baseUrl}/settings/lms-collector/delete-collect-setting.do`, params);
  },
  /**
   * 수집기 비밀번호 변경
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateCollectorPassword(params) {
    return axios.post(`${baseUrl}/settings/lms-collector/update-collect-password.do`, params);
  },

  /**
  * 수집기 비밀번호 체크
  * @author leesy918
  * @param  {[type]} params [description]
  * @return {[type]}        [description]
  */
  checkCollectorPassword(params) {
    return axios.post(`${baseUrl}/settings/lms-collector/check-collect-password.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/lms-collector-setting.js